// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import 'channels';

import 'jquery';

Rails.start();
Turbolinks.start();
ActiveStorage.start();

import 'chartkick/chart.js';
import './m';
import './application_view';
import './communication_management';
import './product_update';
import './manual_my_post';
import './manual_my_post_display';
import './ugc_optimization';
import './darkmode';
import './chat_bot';
import './chat_option';
import './crm';
import './contents';
import './contents_list';
import './popup';
import './site_insert';
import './block_exit';
import './push_notification';
import './personalize';
import './personalize_list';
import './heatmap_preset';
import './recommend_settings';
import './recommend_group_setting';
import './recommend_search_settings';
import './recommend_tuning_setting';
import './recommend_retargeting_setting';
import './recommend_preview';
import './sales_index';
import './recommend_campaign_setting';
import './admin';
import './non_deletable_sns_post';
import './staff';
